import http from '@/plugins/axios/axios';

export default class FolgaService {

    salvar(requisicao) {       
        return http.post('/api/folga/salvar', requisicao);
    }  

    alterar(requisicao) {       
        return http.post('/api/folga/alterar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/folga/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/folga/buscar', requisicao);
    }

    buscarItemSolicitacao(requisicao) {       
        return http.post('/api/folga/buscar-item-solicitacao', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/folga/listar', requisicao);
    }    

    resolverPendenciaNovo(requisicao) {       
        return http.post('/api/folga/resolver-pendencia-novo', requisicao);
    }
    
    resolverPendenciaExcluir(requisicao) {       
        return http.post('/api/folga/resolver-pendencia-excluir', requisicao);
    }
}